const Item = require('./Item.jsx');
const ItemContainer = require('./ItemContainer.jsx');
const ItemMeta = require('./ItemMeta.jsx');
const List = require('../common/List.jsx');
const Name = require('../utility/Name.jsx');

const Blocks = {
    get: (group, data) => [
        {
            id: 'mosaicSeparator',
            dataType: 'separator',
            display: 'Mosaic',
            group
        },
        {
            id: Name.Block.ListTitle,
            component: List.TitleV2.Component,
            config: {
                Block: List.TitleV2.TypeConfig.panel.block(true),
                Visibility: List.TitleV2.TypeConfig.panel.visibility({ configurableDuringExport: (type) => type == 'mosaics' }),
                Style: List.TitleV2.TypeConfig.panel.style()
            },
            display: 'List Title\n(Quicklists Only)',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Container,
            component: ItemContainer.ComponentV2,
            config: {
                Block: ItemContainer.TypeConfigV2.panel.block(),
                Style: ItemContainer.TypeConfigV2.panel.style(),
                Visibility: ItemContainer.TypeConfigV2.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ItemContainer.TypeConfigV2.defaultDesign(data) }
                ]
            },
            display: 'Item Container',
            group,
            image: '',
            type: 'container'
        }
    ],
    content: {
        [Name.Block.Inventory.Container]: ItemContainer.Blocks
    },
    tokens: (id, data) => {
        switch (id) {
            case Name.Block.Inventory.Meta:
                return ItemMeta.Tokens(data);
            case Name.Block.ListTitle:
                return List.TitleV2.Tokens();
        }
    },

    legacy: [
        { display: 'Mosaic Data Blocks', type: 'header' },
        {
            id: 'listTitle',
            component: List.Title.Component,
            config: {
                Block: List.Title.TypeConfig.panel.block({}),
                Visibility: List.Title.TypeConfig.panel.visibility({ configurableDuringExport: function (type) { return type == 'mosaics'; } }),
                Style: List.Title.TypeConfig.panel.style()
            },
            display: 'List Title (Quicklists Only)',
            image: ''
        },
        { display: 'Item Data Blocks', type: 'header' },
        {
            id: 'itemContainer',
            component: ItemContainer.Component,
            config: {
                Block: ItemContainer.TypeConfig.panel.block(),
                Columns: ItemContainer.TypeConfig.panel.columns(),
                Style: ItemContainer.TypeConfig.panel.style()
            },
            display: 'Item Container (required)',
            image: '',
            type: 'container'
        },
        {
            id: 'itemImage',
            component: Item.Image.Component,
            config: {
                Block: Item.Image.TypeConfig.panel.block(),
                Style: Item.Image.TypeConfig.panel.style()
            },
            display: 'Image',
            image: ''
        },
        {
            id: 'itemArtist',
            component: Item.Artist.Component,
            config: {
                Block: Item.Artist.TypeConfig.panel.block(),
                Style: Item.Artist.TypeConfig.panel.style()
            },
            display: 'Artist',
            image: ''
        },
        {
            id: 'itemTitle',
            component: Item.Title.Component,
            config: {
                Block: Item.Title.TypeConfig.panel.block(),
                Includes: Item.Title.TypeConfig.panel.includes({}),
                Style: Item.Title.TypeConfig.panel.style()
            },
            display: 'Title',
            image: ''
        },
        {
            id: 'itemEdition',
            component: Item.Edition.Component,
            config: {
                Block: Item.Edition.TypeConfig.panel.block(),
                Visibility: Item.Edition.TypeConfig.panel.visibility({}),
                Style: Item.Edition.TypeConfig.panel.style(),
                Format: Item.Edition.TypeConfig.panel.format()
            },
            display: 'Edition Info',
            image: ''
        },
        {
            id: 'itemMedium',
            component: Item.Medium.Component,
            config: {
                Block: Item.Medium.TypeConfig.panel.block(),
                Visibility: Item.Medium.TypeConfig.panel.visibility(),
                Style: Item.Medium.TypeConfig.panel.style()
            },
            display: 'Medium',
            image: ''
        },
        {
            id: 'itemSignature',
            component: Item.Signature.Component,
            config: {
                Block: Item.Signature.TypeConfig.panel.block(),
                Visibility: Item.Signature.TypeConfig.panel.visibility(),
                Style: Item.Signature.TypeConfig.panel.style()
            },
            display: 'Signature',
            image: ''
        },
        {
            id: 'itemDimensions',
            component: Item.Dimensions.Component,
            config: {
                Block: Item.Dimensions.TypeConfig.panel.block(),
                Visibility: Item.Dimensions.TypeConfig.panel.visibility(),
                Style: Item.Dimensions.TypeConfig.panel.style()
            },
            display: 'Dimensions',
            image: ''
        },
        {
            id: 'itemAlternateDimensions',
            component: Item.AlternateDimensions.Component,
            config: {
                Block: Item.AlternateDimensions.TypeConfig.panel.block(),
                Visibility: Item.AlternateDimensions.TypeConfig.panel.visibility(),
                Style: Item.AlternateDimensions.TypeConfig.panel.style()
            },
            display: 'Alternate Dimensions',
            image: ''
        },
        {
            id: 'itemFramed',
            component: Item.Framed.Component,
            config: {
                Block: Item.Framed.TypeConfig.panel.block(),
                Visibility: Item.Framed.TypeConfig.panel.visibility(),
                Style: Item.Framed.TypeConfig.panel.style()
            },
            display: 'Framed',
            image: ''
        },
        {
            id: 'itemPrice',
            component: Item.Price.Component,
            config: {
                Block: Item.Price.TypeConfig.panel.block(),
                Visibility: Item.Price.TypeConfig.panel.visibility(),
                Style: Item.Price.TypeConfig.panel.style(),
                Format: Item.Price.TypeConfig.panel.format()
            },
            display: 'Price',
            image: ''
        },
        {
            id: 'itemDisplayPrice',
            component: Item.DisplayPrice.Component,
            config: {
                Block: Item.DisplayPrice.TypeConfig.panel.block(),
                Visibility: Item.DisplayPrice.TypeConfig.panel.visibility(),
                Style: Item.DisplayPrice.TypeConfig.panel.style()
            },
            display: 'Display Price',
            image: ''
        },
        {
            id: 'itemLocation',
            component: Item.Location.Component,
            config: {
                Block: Item.Location.TypeConfig.panel.block(),
                Visibility: Item.Location.TypeConfig.panel.visibility(),
                Style: Item.Location.TypeConfig.panel.style()
            },
            display: 'Location',
            image: ''
        },
        {
            id: 'itemNumber',
            component: Item.Number.Component,
            config: {
                Block: Item.Number.TypeConfig.panel.block(),
                Visibility: Item.Number.TypeConfig.panel.visibility(),
                Style: Item.Number.TypeConfig.panel.style()
            },
            display: 'Inventory Number',
            image: ''
        },
        {
            id: 'itemSKU',
            component: Item.SKU.Component,
            config: {
                Block: Item.SKU.TypeConfig.panel.block(),
                Visibility: Item.SKU.TypeConfig.panel.visibility(),
                Style: Item.SKU.TypeConfig.panel.style()
            },
            display: 'SKU',
            image: ''
        },
        {
            id: 'itemCustomMeta',
            component: Item.CustomMeta.Component,
            config: {
                Meta: Item.CustomMeta.TypeConfig.panel.meta(),
                Includes: Item.CustomMeta.TypeConfig.panel.includes(),
                Style: Item.CustomMeta.TypeConfig.panel.style()
            },
            display: 'Customized Details',
            image: ''
        }
    ]
};

module.exports = {
    Blocks
};